import React, { useState } from 'react';
import { Box, FormControl, Select, MenuItem, Input, Typography, IconButton } from '@mui/material';
import type { Select as SelectType, Option } from '../../pages/app-settings/types';
import CancelIcon from '../../assets/icons/cancel-icon';
import AcceptIcon from '../../assets/icons/accept-icon';

type SettingProperties = {
  select: SelectType;
  id: string;
  callback: Function;
  value: string;
};

const Setting = ({ select, id, callback, value }: SettingProperties) => {
  const [setting, setSetting] = useState<any[]>([]);

  const findAppropriateValue = (defaultValue: any) => {
    if (setting.length > 0) return setting;
    if (value && typeof value === 'string') return [value];
    if (value) return value;
    return defaultValue;
  };

  return (
    <Box
      key={`${id}-${select.title}`}
      display="flex"
      width="100%"
      p={4}
      justifyContent="space-between"
    >
      <Box>
        <Typography variant="h6" id={`${id}-${select.title}-label`}>
          {select.title}
        </Typography>
        {select.description && (
          <Typography id={`${id}-${select.title}-description`}>{select.description}</Typography>
        )}
      </Box>
      <Box>
        <FormControl>
          <Select
            variant="standard"
            id={`${id}-${select.title}-select`}
            multiple={select.multiSelect}
            value={findAppropriateValue(select.defaultValue)}
            onChange={(event: any) => setSetting(event.target.value)}
            input={<Input />}
            style={{ maxWidth: '200px' }}
          >
            {select.options.map((optionInstance: Option) => (
              <MenuItem
                key={optionInstance.label}
                id={`${id}-${select.title}-${optionInstance.label}`}
                value={optionInstance.value}
              >
                {optionInstance.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {setting.length > 0 && (
          <>
            <IconButton
              onClick={() => {
                setSetting([]);
                callback(setting);
              }}
              aria-label="edit"
              size="large"
            >
              <AcceptIcon />
            </IconButton>
            <IconButton onClick={() => setSetting([])} aria-label="edit" size="large">
              <CancelIcon />
            </IconButton>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Setting;
